class SelectText{
    constructor() {
        this.selectors = document.querySelectorAll('[data-select-text-block]')
        this.arraySelectors = Array.from(this.selectors)

        this.init()
    }
    init(){
        this.arraySelectors.forEach(selector => {
            selector.addEventListener('click', e => {
                this.selectAllTextInBlock(selector)
            })
        })
    }
    selectAllTextInBlock(selector){
        if (document.selection) { // IE
            let range = document.body.createTextRange();
            range.moveToElementText(selector);
            range.select();
        } else if (window.getSelection) {
            let range = document.createRange();
            range.selectNode(selector);
            window.getSelection().removeAllRanges();
            window.getSelection().addRange(range);
        }
    }
}

new SelectText()